// src/components/LanguageSwitcher.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();
    return (
        <div style={{ marginLeft: 'auto' }}>
            <button style={{ marginRight: '5px' }} onClick={() => i18n.changeLanguage('pl')} disabled={i18n.language === 'pl'}>PL</button>
            <button style={{ marginRight: '5px' }}  onClick={() => i18n.changeLanguage('en')} disabled={i18n.language.startsWith('en')}>EN</button>
            <button style={{ marginRight: '5px' }}  onClick={() => i18n.changeLanguage('es')} disabled={i18n.language.startsWith('es')}>ES</button>
        </div>
    );
};